// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/exports-last */
/** @jsx jsx */
// eslint-disable-next-line no-unused-vars
import React, { forwardRef } from 'react'
import styled from '@emotion/styled'
import {
  Heading as Heading2,
  Text as Text2,
  Box as Box2,
  Flex as Flex2,
  Container as Container2,
  Image as Image2,
  AspectImage as AspectImage2,
  Button as Button2,
} from '@theme-ui/components'
import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'
import parse from 'html-react-parser'
import {
  background,
  border,
  color,
  compose,
  flexbox,
  grid,
  layout,
  position,
  shadow,
  space,
  typography,
} from 'styled-system'
import { BaseStyles, jsx } from 'theme-ui'
import ContactForm from './contact'
import { CTASection } from './CTASection'
import useHomeButtonImage from '../hooks/useHomeButtonImage'

const composed = compose(
  typography,
  space,
  color,
  layout,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow,
)

export const GatsbyLink = ({ ...props }) => <Link {...props} />

export const ALink = props => (
  <GatsbyLink
    sx={{
      variant: 'styles.a',
    }}
    {...props}
  />
)
export const NavLink = props => (
  <GatsbyLink
    sx={{
      '&:hover': {
        color: 'secondary',

        '.filled': {
          fill: 'primary',
          stroke: 'primary',
        },
      },
      variant: 'links.nav',
    }}
    {...props}
  />
)
export const Heading = styled(Heading2)(composed)
export const Text = styled(Text2)(composed)
export const Box = styled(Box2)(composed)
export const Flex = styled(Flex2)(composed)

export const PopMenuItem = forwardRef(({ children, ...rest }, ref) => {
  return (
    <GatsbyLink>
      <Text ref={ref} display="block" {...rest}>
        {children}
      </Text>
    </GatsbyLink>
  )
})

export const ImageWrapper = ({ ...props }) => (
  <Box
    width="100%"
    sx={{
      height: 'fill-available !important',
      div: { height: 'fill-available !important' },
    }}
    {...props}
  />
)

export const Container = styled(Container2)(composed)
export const Image = styled(Image2)(composed)
export const AspectImage = styled(AspectImage2)(composed)
export const Button = styled(Button2)(composed)

export const FlexGrid = ({ ...props }) => <Flex sx={{ flexWrap: 'wrap' }} {...props} />

export const BackgroundLayer = props => (
  <Box width="100%" height="100%" mx="auto" position="absolute" bottom={0} zIndex={-1} {...props} />
)
export const ForegroundLayer = props => (
  <Box width="100%" height="100%" mx="auto" position="absolute" bottom={0} zIndex={1} {...props} />
)

export const Col = ({ ...props }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}
    {...props}
  />
)

const replace = {
  replace: domNode => {
    if (domNode.attribs && domNode.attribs.class === 'ctaSection') {
      return <CTASection src="https://player.vimeo.com/video/379897232" />
    }
    if (domNode.attribs && domNode.attribs.class === 'contactForm') {
      return <ContactForm />
    }
    return null
  },
}

export const Html = ({ baseStyles = true, ...props }) => {
  const html2 = props.html

  return (
    <Box {...props}>
      {baseStyles ? <BaseStyles>{parse(html2, replace)}</BaseStyles> : parse(html2, replace)}
    </Box>
  )
}
export const VerticalLine = ({ ...props }) => (
  <svg viewBox="0 0 1 500" {...props}>
    <line
      x1="0"
      x2="0"
      y2="500"
      stroke="rgba(0, 0, 0, 0.1)"
      strokeWidth="20"
      strokeOpacity="1"
      data-reactid=".0.1.$3/=13.0.0.0.0"
      y1="0"
    />
  </svg>
)

export const SectionTitle = ({ ...props }) => (
  <Heading
    {...props}
    sx={{
      fontSize: [2, 2, 4],
      fontFamily: '"Barlow Condensed", sans-serif',
      lineHeight: 1.2,
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: 0.48,
    }}
  />
)
export const HeaderText = ({ ...props }) => (
  <Heading
    sx={{
      fontSize: [5, 5, 6, 7],
      fontFamily: '"Barlow Condensed", sans-serif',
      fontWeight: 700,
      lineHeight: '1',
    }}
    {...props}
  />
)

export const PlayButton = ({ ...props }) => {
  const HomeVideoThumbImage = useHomeButtonImage()
  return (
    // eslint-disable-next-line react/no-unknown-property
    <div sx={{ maxWidth: 400, mx: 'auto', cursor: 'pointer' }} {...props}>
      <GatsbyImage
        id="playbutton"
        style={{ display: 'block', margin: 'auto' }}
        image={HomeVideoThumbImage}
        alt="Watch Video"
      />
    </div>
  )
}
